import { render } from "./Sales_Management.vue?vue&type=template&id=5df57eb8"
import script from "./Sales_Management.vue?vue&type=script&lang=js"
export * from "./Sales_Management.vue?vue&type=script&lang=js"

import "./Sales_Management.vue?vue&type=style&index=0&id=5df57eb8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__